import { Directive, Input, OnDestroy, ApplicationRef, TemplateRef, EmbeddedViewRef, Injector, ComponentRef, Optional } from '@angular/core';
import { isNullOrEmpty } from '@awp/core/utils';
import { DynamicOutletService } from '@awp/dynamic-outlet';

@Directive({
  selector: 'ap-content-outlet,[apContentOutlet]',
})
export class ContentOutletDirective implements OnDestroy {

  @Input('apContentOutlet') outletId: string;
  @Input('contentTemplate') templateRef: TemplateRef<any>;
  @Input() componentName: string;

  private _viewRef: EmbeddedViewRef<any>;
  private _componentRef: ComponentRef<any>;
  private _applicationRef: ApplicationRef;
  private _dynamicOutletService: DynamicOutletService;

  constructor(
    private injector: Injector,
    @Optional() private attachedTemplateRef?: TemplateRef<any>) { }

  ngOnDestroy() {
    this.destroyComponent();
  }

  public createComponent(element: HTMLElement): void {
    this.destroyComponent();

    if (this.templateRef != null) {
      // Attach to the specified template reference
      this._viewRef = this.templateRef.createEmbeddedView(null);
      this.applicationRef.attachView(this._viewRef);

      const domElement = this._viewRef.rootNodes[0] as HTMLElement;
      element.appendChild(domElement);

      if (this._viewRef != null) {
        this._viewRef.markForCheck();
      }

    } else if (!isNullOrEmpty(this.componentName)) {
      // Attach to specified component name
      this.outletService.getComponent(this.componentName, this.injector)
        .then(componentRef => {
          this._componentRef = componentRef;
          this.applicationRef.attachView(componentRef.hostView);
          const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
          element.appendChild(domElem);
          componentRef.changeDetectorRef.markForCheck();
        });
    } else if (this.attachedTemplateRef != null) {
      // Attach using current ng-template reference where the directive is currently specified.
      element.innerHTML = '';
      this._viewRef = this.attachedTemplateRef.createEmbeddedView(null);
      this.applicationRef.attachView(this._viewRef);

      const domElement = this._viewRef.rootNodes[0] as HTMLElement;
      element.appendChild(domElement);

      if (this._viewRef != null) {
        this._viewRef.markForCheck();
      }
    }
  }

  get applicationRef(): ApplicationRef {
    if (this._applicationRef == null) {
      this._applicationRef = this.injector.get<ApplicationRef>(ApplicationRef);
    }
    return this._applicationRef;
  }

  get outletService(): DynamicOutletService {
    if (this._dynamicOutletService == null) {
      this._dynamicOutletService = this.injector.get<DynamicOutletService>(DynamicOutletService);
    }

    return this._dynamicOutletService;
  }

  public destroyComponent(): void {
    if (this._viewRef) {
      this.applicationRef.detachView(this._viewRef);
      this._viewRef.destroy();
      this._viewRef = null;
    }
    if (this._componentRef) {
      this.applicationRef.detachView(this._componentRef.hostView);
      this._componentRef.destroy();
      this._componentRef = null;
    }
  }
}